import MkuBreadcrumbItem from '../breadcrumb/src/breadcrumb-item';

MkuBreadcrumbItem.install = function (Vue) {
  Vue.component(MkuBreadcrumbItem.name, MkuBreadcrumbItem);
};

export default MkuBreadcrumbItem;
